/** Salesforce file extensions for stripping from file names */
export const SF_EXTENSION_REGEX = /\.(cls|trigger|page|component|object|flow|email|xml|resource|app|layout|tab)$/i;

export interface MetadataTypeInfo {
  metadataType: string;
  name: string;
  ext: string;
}

/**
 * Detects the Salesforce metadata type from code content and optionally file name.
 * Returns metadata type, inferred name, and file extension.
 */
export function detectMetadataType(code: string, fileName?: string): MetadataTypeInfo {
  const triggerMatch = code.match(/\btrigger\s+(\w+)\b/);
  const classMatch = code.match(/\bclass\s+(\w+)\b/);
  const lwcMatch = code.match(/import\s+.*from\s+['"]lwc['"]/);
  const auraMatch = code.match(/<aura:component/i);

  if (fileName) {
    if (fileName.endsWith('.trigger') || triggerMatch) {
      return { metadataType: 'ApexTrigger', name: triggerMatch?.[1] || 'NewTrigger', ext: '.trigger' };
    }
    if (fileName.endsWith('.js') || lwcMatch) {
      const lwcNameMatch = code.match(/export\s+default\s+class\s+(\w+)/);
      return { metadataType: 'LightningComponentBundle', name: lwcNameMatch?.[1] || 'NewComponent', ext: '.js' };
    }
    if (fileName.endsWith('.cmp') || auraMatch) {
      return { metadataType: 'AuraDefinitionBundle', name: 'NewAuraComponent', ext: '.cmp' };
    }
  }

  if (triggerMatch) return { metadataType: 'ApexTrigger', name: triggerMatch[1], ext: '.trigger' };
  if (lwcMatch) {
    const lwcNameMatch = code.match(/export\s+default\s+class\s+(\w+)/);
    return { metadataType: 'LightningComponentBundle', name: lwcNameMatch?.[1] || 'NewComponent', ext: '.js' };
  }
  if (auraMatch) return { metadataType: 'AuraDefinitionBundle', name: 'NewAuraComponent', ext: '.cmp' };
  if (classMatch) return { metadataType: 'ApexClass', name: classMatch[1], ext: '.cls' };

  return { metadataType: 'ApexClass', name: 'NewClass', ext: '.cls' };
}
